import { Component, inject } from '@angular/core';
import {
  ActionResult,
  ActionWindowParams,
  DEFAULT_ITEM_VIEW,
  EMPTY_ACTION_RESULT,
  ItemActionResult,
  ListViewProviderDirective,
  Util,
  ViewResult,
  ViewState
} from '@ntap/core';
import {
  EMPTY,
  Observable,
  Subject,
  filter,
  first,
  map,
  mergeMap,
  switchMap,
  tap
} from 'rxjs';
import { ConfirmationService } from 'primeng/api';
import { PrimeNGButtonOpenItemViewActionComponent } from '@ntap/primeng';
import { OpenArhivWindowActionUtil } from '@app/shared/util/open-arhiv-window-util';

@Component({
  selector: 'app-promijeni-lokaciju-fizicki-objekti',
  templateUrl: '../../../shared/components/actions/common-action-template.html'
})
export class PromijeniLokacijuFizickiObjektiActionComponent extends PrimeNGButtonOpenItemViewActionComponent {
  private confirmationService = inject(ConfirmationService);
  listViewProvider = inject(ListViewProviderDirective);

  protected override doExecute(): Observable<ActionResult> {
    const accepted$ = new Subject<boolean>();
    this.confirmationService.confirm({
      message:
        'Jeste li sigurni da želite promijeniti lokaciju fizičkim objektima uključujući i sve na nižim razinama?',
      accept: () => {
        accepted$.next(true);
        accepted$.complete();
        accepted$.unsubscribe();
      },
      reject: () => {
        accepted$.next(false);
        accepted$.complete();
        accepted$.unsubscribe();
      }
    });
    return accepted$.pipe(
      switchMap((e) => {
        if (e) {
          return super.doExecute();
        }
        return EMPTY;
      })
    );
  }

  protected override initDisabledObservable(): void {
    this.isDisabled$ = this.listViewProvider.selectedItems$.pipe(
      map((selectedItems) => {
        return selectedItems.length < 1;
      })
    );
  }

  protected override doExecuteWithItem(): Observable<ItemActionResult> {
    return this.listViewProvider.selectedItems$.pipe(
      first(),
      mergeMap((selectedItems) => {
        const viewState = this.getInitialState(selectedItems);

        return this.doOpenWindow(viewState).pipe(
          filter((viewResult) => this.acceptResult(viewResult)),
          tap(() => this.log('result ACCEPTED')),
          map(
            (viewResult) =>
              new ItemActionResult(EMPTY_ACTION_RESULT, viewResult.viewData[0])
          )
        );
      })
    );
  }

  protected getInitialState(selectedItems: object[]): ViewState {
    return {
      $selected: Util.mapToBasicItemData(selectedItems)
    };
  }

  private doOpenWindow(viewState: ViewState): Observable<ViewResult> {
    return OpenArhivWindowActionUtil.open(
      this.getActionWindowParams(),
      viewState
    );
  }

  protected override getActionWindowParams(): ActionWindowParams {
    this.doSetDefaultActionViewName();
    const actionWindowParams = OpenArhivWindowActionUtil.createParams(
      this.action,
      this.windowRegistry,
      this.getWindowTarget()
    );
    return actionWindowParams;
  }

  private doSetDefaultActionViewName() {
    if (!this.action.$openViewName) {
      this.action.$openViewName = DEFAULT_ITEM_VIEW;
    }
  }
}
